import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './utils/serviceWorker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for caching (delayed to reduce initial TBT)
if (process.env.NODE_ENV === 'production') {
  // Delay service worker registration to not block main thread
  setTimeout(() => {
    serviceWorker.register({
      onSuccess: () => {
        console.log('App cached successfully for offline use');
      },
      onUpdate: (registration) => {
        console.log('New version available, please refresh');
        if (registration && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      }
    });
  }, 2000);
} else {
  serviceWorker.unregister();
}

// Load web vitals only in development
if (process.env.NODE_ENV === 'development') {
  import('./reportWebVitals').then(({ default: reportWebVitals }) => {
    reportWebVitals();
  });
}
